import React from 'react';
import Button from 'shared/buttons';
import useModal from 'shared/../hooks/useModal';
import SearchDriverDispatchesModal from './SearchDriverDispatchesModal';
import { BsTruck } from 'react-icons/bs';

const SearchDriverDispatchesButton = () => {
  const { show: showModal } = useModal(SearchDriverDispatchesModal);

  return (
    <Button
      id='search-driver-dispatches-button'
      iconOnly
      iconComponent={<BsTruck />}
      themeColor='tertiary'
      fillMode='flat'
      onClick={() => showModal()}
    />
  );
};

export default SearchDriverDispatchesButton;
